import i18n from '@i18n';

import { errorHelpers } from './errorHelpers';

export function getMessage(constraints) {
  const errorKey = Object.keys(constraints)[0];

  const error = i18n.t(`errors:validation.${errorKey}`);

  const text = constraints[errorKey];

  const helperText = errorHelpers[errorKey] ? errorHelpers[errorKey](text) : '';

  const errorMessage = `${error} ${helperText}`;

  return errorMessage;
}
